module.exports = __webpack_public_path__ + "img/33348325000119.80228fa2.png";